import { FeatureSelectionTab } from '../interface/featureSelection';
import { ROUTES, UserType } from '../constants/constants';
import { NotificationTemplate } from '../interface/notification';
import { IInAppNotification } from '../interface';
import { IUser } from '../interface/user';

export const useNotificationTemplateConfig = () => {
  const notificationTemplateConfig: Record<
    string,
    { feature: FeatureSelectionTab; route: string; extraParams?: unknown }
  > = {
    [NotificationTemplate.MATTER_OPENED]: {
      feature: FeatureSelectionTab.matters,
      route: ROUTES.MATTER_DETAIL,
    },
    [NotificationTemplate.CRITICAL_TASK_ALERT]: {
      feature: FeatureSelectionTab.tasks,
      route: ROUTES.CRITICAL_TASKS_DETAIL,
    },
    [NotificationTemplate.CRITICAL_TASK_DUE]: {
      feature: FeatureSelectionTab.tasks,
      route: ROUTES.CRITICAL_TASKS_DETAIL,
    },
    [NotificationTemplate.TASK_ALERT]: {
      feature: FeatureSelectionTab.tasks,
      route: ROUTES.TASKS_DETAIL,
    },
    [NotificationTemplate.TASK_DUE]: {
      feature: FeatureSelectionTab.tasks,
      route: ROUTES.TASKS_DETAIL,
    },
    [NotificationTemplate.PRELIMINARY_INVOICE_APPROVAL]: {
      feature: FeatureSelectionTab.invoicing,
      route: ROUTES.PRELIMINARY_INVOICE_DETAIL,
      extraParams: { isFromNotification: true, fromApprovalNotification: true },
    },
    [NotificationTemplate.PRELIMINARY_INVOICE_REVIEW]: {
      feature: FeatureSelectionTab.invoicing,
      route: ROUTES.PRELIMINARY_INVOICE_DETAIL,
      extraParams: { isFromNotification: true },
    },
  };

  return notificationTemplateConfig;
};

export const useNotificationAccessGating = (
  user: IUser | null,
  features: { [key: string]: boolean },
  showFeatureModal: (
    featureToEnable: FeatureSelectionTab,
    notification?: IInAppNotification,
    onConfirm?: (featureToEnable?: FeatureSelectionTab, notification?: IInAppNotification) => void,
  ) => void,
  showRestrictedUserModal: (onConfirm?: () => void) => void,
) => {
  const checkAccessAndProceed = (
    config: { feature: FeatureSelectionTab; route: string; extraParams?: unknown },
    notification: IInAppNotification,
    onProceed: () => void,
  ) => {
    const isFeatureEnabled = features[config.feature];

    if (
      config.feature === FeatureSelectionTab.invoicing &&
      user?.userType === UserType.RESTRICTED
    ) {
      showRestrictedUserModal();
      return;
    }

    if (!isFeatureEnabled) {
      showFeatureModal(
        config.feature,
        notification,
        (
          _featureToEnable: FeatureSelectionTab | undefined,
          notificationData: IInAppNotification | undefined,
        ) => {
          if (notificationData) {
            onProceed();
          }
        },
      );
      return;
    }

    onProceed();
  };

  return { checkAccessAndProceed };
};
